import { mascaraMonetaria } from './mascaras'

export const formatarPorcentagem = (valor) => `${valor * 100}%`
export const formatarValorMonetario = (valor) => mascaraMonetaria(valor)
/**
 * @var dataString {string} - Data a ser formatada
 * @var locale {string} - Locale para formatação (padrão: 'pt-BR')
 * @returns {string} - Data formatada no formato DD/MM/AAAA
 */
export const formatarData = (dataString, locale = 'pt-BR') => {
  const dataComTimezoneDefault = dataString + 'T00:00:00'
  const dataObj = new Date(dataComTimezoneDefault)
  const formatador = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'America/Sao_Paulo'
  })
  return formatador.format(dataObj)
}
